export default __webpack_public_path__ + "static/media/Editorial.9d73b526.svg";